import o from"./_Symbol.js";import t from"./_getRawTag.js";import r from"./_objectToString.js";var e=t,i=r,n=o?o.toStringTag:void 0;var a=function(o){return null==o?void 0===o?"[object Undefined]":"[object Null]":n&&n in Object(o)?e(o):i(o)};export{a as default};
//# sourceMappingURL=_baseGetTag.js.map
